import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useQuery, useSubscription } from 'urql';
import { GraphqlOperations } from '../../../../logic/graphql/operations';
import { Query, Subscription } from '../../../../logic/graphql/types/types';

const BadgeContainer = styled.span`
  position: absolute;
  top: -12px;
  right: -16px;
  height: 18px;
  min-width: 18px;
  background: #eb5757;
  font-weight: bold;
  font-size: 11px;
  line-height: 18px;
  text-align: center;
  letter-spacing: -0.01em;
  border-radius: 9px;
  box-shadow: 0px 0px 10px #eb5757;
  padding: 0px 3px;
`;

const MessageBadge = (): JSX.Element | null => {
  const [messageCount, setMessageCount] = useState<number | undefined>(undefined);
  const messageQueryResult = useQuery<Query>({
    query: GraphqlOperations.queries.get_unread_messages_count.queryString,
  })[0];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleSubscription = (_messageCounts: number[] = [], response: Subscription): number[] => {
    if (response && response.message_unread_count !== undefined) {
      setMessageCount(response.message_unread_count);
    }
    return [];
  };

  useSubscription(
    {
      query: GraphqlOperations.subscriptions.message_unread_count.subscriptionString,
    },
    handleSubscription,
  );

  const messageCountData = messageQueryResult.data?.get_unread_messages_count;

  useEffect(() => {
    if (messageCount === undefined && messageCountData !== undefined) {
      setMessageCount(messageCountData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageCountData]);

  const indicatedMessagesCount = messageCount
    ? messageCount < 100
      ? messageCount
      : '99+'
    : undefined;

  if (indicatedMessagesCount) {
    return <BadgeContainer>{indicatedMessagesCount}</BadgeContainer>;
  }
  return null;
};

export default MessageBadge;
